'use client'

import React, { memo } from 'react'

export interface SelectOption {
  value: string | number
  label: string
}

interface SelectFieldProps {
  id: string
  value: string | number
  onChange: (value: string | number) => void
  options: SelectOption[]
  ariaLabel?: string
  valueParser?: (value: string) => string | number
}

const SelectField = memo<SelectFieldProps>(({
  id,
  value,
  onChange,
  options,
  ariaLabel,
  valueParser = (val) => val
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const rawValue = e.target.value
    const parsedValue = valueParser(rawValue)
    onChange(parsedValue)
  }

  return (
    <select
      id={id}
      value={value}
      onChange={handleChange}
      className="w-full px-3 py-2 bg-slate-800/50 border border-slate-600/50 rounded-lg text-slate-200 focus:border-cyan-400/50 focus:outline-none focus:ring-1 focus:ring-cyan-400/30"
      aria-label={ariaLabel}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
})

SelectField.displayName = 'SelectField'

export default SelectField